module.exports = __webpack_public_path__ + "img/Group 63.75dd2ae6.svg";